import { useEffect, useState } from "react";
import { sendPushNotification } from "../api/common.api";
import { useRecoilState, useRecoilValue } from "recoil";
import { artistListState, deviceListState, userListState } from "../atom/atom";
import {
  fetchAndSetData,
  fetchDeviceList,
  fetchUserList,
} from "../api/fetch.api";
import CommonButton from "../components/CommonButton";
import "./styles/PushNotificationPage.module.css";
import CopyText from "../components/CopyText";
import { Artist } from "../types/type";

function PushNotificationPage() {
  const totalArtistList = useRecoilValue(artistListState);
  const [deviceList, setDeviceList] = useRecoilState(deviceListState);
  const [userList, setUserList] = useRecoilState(userListState);
  const [selectedArtist, setSelectedArtist] = useState<Artist | null>(null);
  const [title, setTitle] = useState<string>("공지사항");
  const [content, setContent] = useState<string>("내용을 입력하세요.");

  useEffect(() => {
    if (userList.length === 0) {
      fetchAndSetData(fetchUserList, setUserList); // fetchUserList는 사용자 목록을 가져오는 API 함수로 가정
    }
  }, [userList]);

  const filteredUserList = selectedArtist
    ? userList.filter((user) =>
        selectedArtist?.followerIdList.includes(user.userId)
      )
    : userList;

  const handleSendNotification = async (tokens: string[]) => {
    if (!title || !content || tokens.length === 0) return;

    console.log("handleSendNotification tokens :", tokens);

    const body = {
      title,
      body: content,
      tokenList: tokens,
      data: {
        songTitle: "custom",
        screen: "Search",
        songId: "0",
      },
    };

    try {
      await sendPushNotification(body);
    } catch (error) {
      console.error("Failed to send push notification:", error);
    }
  };

  const handleArtistSelect = (artist: Artist | null) => {
    setSelectedArtist(artist);
  };

  const handleSendToAll = () => {
    const allTokens = userList.map((user) => user.fcmToken).filter(Boolean);
    handleSendNotification(allTokens);
  };

  const handleSendToArtistFollowers = () => {
    const artistTokens = filteredUserList
      .map((user) => user.fcmToken)
      .filter(Boolean);
    handleSendNotification(artistTokens);
  };

  return (
    <div className="push-notification-page">
      <h1>Push Notification Management</h1>
      <div className="notification-form">
        <div className="input-group">
          <label>
            Title:
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>
        </div>
        <div className="input-group">
          <label>
            Content:
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              style={{ width: "100%", height: "100px" }}
            />
          </label>
        </div>
      </div>
      <div className="artist-selection">
        <CommonButton
          onClick={() => handleArtistSelect(null)}
          selected={selectedArtist === null}
        >
          모든 아티스트
        </CommonButton>
        {totalArtistList.map((artist) => (
          <CommonButton
            key={artist.artistId}
            onClick={() => handleArtistSelect(artist)}
            selected={selectedArtist === artist}
          >
            {artist.artistName}
          </CommonButton>
        ))}
      </div>
      <div className="notification-actions">
        <button onClick={handleSendToAll}>모든 유저에게 보내기</button>
        {selectedArtist && (
          <button onClick={handleSendToArtistFollowers}>
            {selectedArtist.artistName} 팔로워에게 보내기
          </button>
        )}
      </div>
      <div className="user-list">
        <h2>{selectedArtist?.artistName || "모든 유저"} 리스트</h2>
        <ul>
          <li className="user-list-header">
            <span>User ID</span>
            <span>이름</span>
            <span>Email</span>
            <span>Token</span>
            <span>Action</span>
          </li>
          {filteredUserList
            .filter((user) => user.fcmToken)
            .map((user) => (
              <li key={user.userId}>
                <span>{user.userId.slice(0, 10) || "N/A"}</span>
                <span>{user.userName || "N/A"}</span>
                <span>{user.email || "N/A"}</span>
                <CopyText text={user.fcmToken} />
                <span
                  onClick={() => handleSendNotification([user.fcmToken])}
                  style={{
                    cursor: "pointer",
                    border: "1px solid red",
                  }}
                >
                  알림 보내기
                </span>
              </li>
            ))}

          {/* 구분선 추가 */}
          <hr style={{ margin: "20px 0" }} />

          {/* fcmToken이 없는 user들을 구분선 아래에 표시 */}
          {filteredUserList
            .filter((user) => !user.fcmToken)
            .map((user) => (
              <li key={user.userId}>
                <span>{user.userId.slice(0, 10) || "N/A"}</span>
                <span>{user.userName || "N/A"}</span>
                <span>{user.email || "N/A"}</span>
                <span>{"N/A"}</span>
                <span
                  style={{
                    cursor: "not-allowed",
                    color: "gray",
                  }}
                >
                  알림 불가
                </span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default PushNotificationPage;
